import React from 'react'
import { VictoryLabel, VictoryLabelProps } from 'victory'

import { Color, Font } from '../../style'

interface Props extends VictoryLabelProps {
  xLabel?: string
  yLabel?: string
}
const ChartFlyover = (props: Props) => {
  const labelStyle = { fontFamily: Font.light, fill: Color.calmGrey, fontSize: 12 }
  const valueStyle = { fontFamily: Font.medium, fill: Color.premiumBlack, fontSize: 12 }
  return <VictoryLabel {...props} style={[labelStyle, valueStyle, labelStyle, valueStyle]} lineHeight={[1, 2, 1, 1]} />
}

export default ChartFlyover
